import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <main className="not-found" role="main" aria-labelledby="not-found-title">
            <div className="not-found__card">
                <span className="not-found__code">404</span>
                <h1 id="not-found-title">Страница не найдена</h1>
                <p>
                    Похоже, ссылка устарела или была введена с ошибкой.
                    Вернитесь на главную страницу или откройте игру.
                </p>
                <div className="not-found__actions">
                    <Link to="/" className="not-found__button not-found__button--primary">
                        На главную
                    </Link>
                    <Link to="/game" className="not-found__button">
                        Перейти в игру
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default NotFound;
